class ManualReviews extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick)
  }

  handleClick () {
    if (this.externalEls?.target?.element) {
      this.externalEls.target.element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }
}

if (!customElements.get('manual-reviews')) {
  customElements.define('manual-reviews', ManualReviews)
}
